import { MutableRefObject } from 'react'

import { restoreStaticValues } from '../../helpers'
import { playInvoiceStep } from './invoice-playback'
import { playProductStep } from './product-playback'

type PackagingStepParams = {
  activeInvoiceValuesRef: MutableRefObject<StaticValueState[]>
  controls: PlaybackControls
  fields: AnimatedField[]
  onComplete(): void
  stepElement: HTMLElement
}

export const playPackagingStep = async ({
  activeInvoiceValuesRef,
  controls,
  fields,
  onComplete,
  stepElement,
}: PackagingStepParams): Promise<boolean> => {
  const packagingForm = await playInvoiceStep({
    activeInvoiceValuesRef,
    controls,
    fields,
    stepElement,
  })

  if (!packagingForm) {
    return false
  }

  const productIsComplete = await playProductStep({
    ...packagingForm,
    controls,
    onComplete,
    stepElement,
  })

  restoreStaticValues(activeInvoiceValuesRef.current)
  activeInvoiceValuesRef.current = []

  return productIsComplete
}

